import { ELPLAN_REFRESH_EVENT_QUERY_KEY } from 'api/elplan/elplan.constants'
import { useTranslation } from 'react-i18next'
import elplanStore from 'store/elplan/elplan'
import { Card } from 'ui/atoms'
import UiConfig from 'ui/uiConfig/UiConfig'
import Datetime from 'utils/datetime/datetime'
import { useSnapshot } from 'valtio'

export default function DayAheadOverview() {
  const { t } = useTranslation()
  const elplanSnap = useSnapshot(elplanStore)

  const datasetStartTime = elplanSnap.date.start_time ?? Datetime.getTomorrowDate().startTime
  const datasetEndTime = elplanSnap.date.end_time ?? Datetime.getTomorrowDate().endTime

  return (
    <Card title={t('Day ahead overview')}>
      <UiConfig
        type="day_ahead_overview"
        datasetStartTime={datasetStartTime}
        datasetEndTime={datasetEndTime}
        datasetRefreshToken={ELPLAN_REFRESH_EVENT_QUERY_KEY}
      />
    </Card>
  )
}
